import React from 'react';
import { useSelector } from 'react-redux';
import { IconLoader } from 'common/IconLoader';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import Button from 'components/shared/Button';

import styles from './UserProfile.module.css';

const UserProfile = ({ changePasswordOnClick, logoutOnClick }) => {
  const user = useSelector((state) => state.data.user);
  const rolePermissions = useSelector((state) => state.data.rolePermissions);
  const roleList = rolePermissions?.roles ? rolePermissions.roles.map((role) => role.role) : [];

  return (
    <div className={styles.wrapper}>
      <div className={styles.root}>
        <div className={styles.userInfoWrapper}>
          <div className={styles.profilePic}>
            <img src={user.picture} alt="" />
          </div>
          <div className={styles.nameEmail}>
            <div className={styles.name}>{user?.nickname}</div>
            <div className={styles.email}>{user?.name}</div>
          </div>
        </div>
        <div className={styles.rolesWrapper}>
          <div className={styles.subheader}>Roles</div>
          <div className={styles.roleList}>
            {roleList.map((role) => (
              <div className={styles.role}>{role}</div>
            ))}
          </div>
        </div>
        <div className={styles.rolesWrapper}>
          <div className={styles.subheader}>
            Alternate Id
            <span className={styles.altIdIcon}>
              <SvgAF
                img={IconLoader.icon_info}
                hover={IconLoader.icon_info_hover}
                tooltip={'user tag'}
                tooltipMultiline={true}
              />
            </span>
          </div>
          <div className={styles.altId}>{user?.userTag}</div>
        </div>
        <div className={styles.buttonsWrapper}>
          <Button
            type="submit"
            variant="contained"
            size="medium"
            className={styles.button}
            onClick={changePasswordOnClick}
          >
            Change Password
          </Button>
          <Button type="submit" variant="contained" size="medium" className={styles.button} onClick={logoutOnClick}>
            Logout
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
